import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvironmentService } from '../../../environments/environment.service';
import { UserManagementService } from '../../service/user-management.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly loginUrl = '';
  private readonly logoutUrl = '';
  url: string;
  configsCopy: any;

  constructor(private readonly http: HttpClient, private readonly environmentService: EnvironmentService, private readonly userManagementService: UserManagementService, private readonly toastr: ToastrService) {
    this.getAgencyId();
    this.url = window.location.href;
  }

  private getHeaders(): HttpHeaders {
    const userId = sessionStorage.getItem('userId');
    const agencyId = sessionStorage.getItem('agencyId');
    let headers = new HttpHeaders();

    if (userId) {
      headers = headers.set('user-id', userId);
    }
    if (agencyId) {
      headers = headers.set('agency-id', agencyId);
    }

    return headers;
  }

  getAgencyId() {
    const currentUrl = window.location.href;
    const baseUrl = new URL(currentUrl).host;

    this.userManagementService.getAgencyId(baseUrl).subscribe(
      (data: { agencyId?: string }) => {
      const agencyId = data?.agencyId;
      const agency = data;
      if (agencyId) { 
        sessionStorage.setItem('agencyId', agencyId);
      }
      if (agency) { 
        sessionStorage.setItem('agency', JSON.stringify(agency));
      }
      console.log(agency);
      },
      (error: any) => {
        console.error('There was an error fetching agency id:', error);
        this.toastr.error('There was an error fetching agency id. Please try again.');
      }
    );
  }

  //not using anymore, due to SSO login.
  login(email: string, password: string): Observable<any> {
    const body = { email, password };
    return this.http.post<any>(this.loginUrl, body).pipe(
      tap((response) => {
        if (response.access_token) {
          localStorage.setItem('authToken', response.access_token);
          localStorage.setItem('userEmail', response.user || ''); // Store additional user info if needed
        }
      })
    );
  }

  initiateAzureADLogin() {
    const agencyId = sessionStorage.getItem('agencyId');
    if (agencyId) {
      this.environmentService.getEnvironmentConfig(agencyId).subscribe((configData) => {
        console.log('config',configData);
         //configData.redirect_uri = 'http://localhost:4200/dashboard'; // uncomment thsi line to use in local environment
        if(configData) {
          const authUrl = `${configData.authority}/oauth2/v2.0/authorize?p=${configData.signin_policy}&client_id=${configData.client_id}&redirect_uri=${encodeURIComponent(
          configData.redirect_uri || ''
          )}&scope=${configData.scope}&response_type=${configData.response_type}&prompt=${configData.prompt}`;
          window.location.href = authUrl;  // Redirect to Azure AD login page
        }
        else {
          this.toastr.error('There was an error fetching environment configuration data. Please try again.');
        }
      },
    (error) => {
      console.error("There was an error fetching environment configuration data:", error);
      this.toastr.error('There was an error fetching environment configuration data. Please try again.');
    });
    }
  }

  handleLogin(idToken: string): Observable<void> {
    // Store the token and perform any additional user setup
    localStorage.setItem('authToken', idToken);
    return of(void 0); // Return an observable to match the signature
  }
  //not using anymore, due to SSO login.
  logout(): Observable<void> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post<void>(this.logoutUrl, {}, { headers }).pipe(
      tap(() => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userEmail');
      })
    );
   }

   initiateAccountSetup() {
    const currentUrl = window.location.href;
    const baseUrl = new URL(currentUrl).host;
    
    this.userManagementService.getAgencyId(baseUrl).subscribe({
      next: (data: any) => {
        if (data?.agencyId) {
          this.environmentService.getPasswordConfig(data.agencyId).subscribe({
            next: (configData: any) => {
              console.log('Config Account Setup', configData);
              // Construct the URL using the response
              const authUrl = `${configData.authority}/oauth2/v2.0/authorize?p=${configData.signin_policy}&client_id=${configData.client_id}&redirect_uri=${encodeURIComponent(
                configData.redirect_uri
              )}&scope=${configData.scope}&response_type=${configData.response_type}&prompt=${configData.prompt}`;

              console.log('Generated Account Setup URL:', authUrl);
              window.location.href = authUrl; // Redirect to the constructed URL
            },
            error: (error: any) => {
              console.error('Error fetching password config for account setup:', error);
              this.toastr.error('Error fetching password config. Please try again.');
            }
          });
        } else {
          console.error('Agency ID not found');
          this.toastr.error('Agency ID not found. Please try again.');
        }
      },
        error: (error: any) => {
          console.error('There was an error fetching agency id:', error);
          this.toastr.error('There was an error fetching agency id. Please try again.');
        }
      });
    }
}
